import { PropType, defineComponent, ref } from 'vue';
import SVG from '@dts/shared/src/assets/svg';
import styles from './index.module.scss';
import { NButton, NDropdown } from 'naive-ui';
import { useRoute, useRouter } from 'vue-router';

const Search = defineComponent({
  setup: (props) => {
    const showExpandMenu = ref(false);
    const router = useRouter();
    const route = useRoute();

    const handleSelect = (key: string | number) => {
      console.info('key--->', key);
    };

    const handleClick = () => {
      if (route.name === 'Search') {
        router.go(0);
      } else {
        router.push({
          name: 'Search',
        });
      }

      showExpandMenu.value = true;
    };

    return () => (
      <NDropdown
        show={showExpandMenu.value}
        // options={options}
        onSelect={handleSelect}
        onClickoutside={() => (showExpandMenu.value = false)}
      >
        <NButton
          size="large"
          text
          class={styles.search}
          onClick={handleClick}
          v-slots={{
            icon: () => <SVG.SearchSVG />,
          }}
        ></NButton>
      </NDropdown>
    );
  },
});
export default Search;
